import ReportUserContainer from '../ReportUserContainer';
import ValuatedReportUser, { ValuatedReportUserData } from './ValuatedReportUser';

export default class ValuatedReportUserContainer extends ReportUserContainer<ValuatedReportUser> {
  public getReport(): ValuatedReportUserData[] {
    return Object.keys(this.users).map((userId) => this.users[userId].getUser());
  }
}
